var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbol",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/Unit/Profile",
    transform: "translate(-1.000000, -1.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(1.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#ffc440",
    x: 0,
    y: 0,
    width: 18,
    height: 18,
    rx: 7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9,10.5833333 C10.6666667,10.5833333 14,11.5 14,13.1666667 L14,14 L4,14 L4,13.1666667 C4,11.5 7.33333333,10.5833333 9,10.5833333 Z M9,4 C10.3833333,4 11.5,5.11666667 11.5,6.5 C11.5,7.88333333 10.3833333,9 9,9 C7.61666667,9 6.5,7.88333333 6.5,6.5 C6.5,5.11666667 7.61666667,4 9,4 Z",
    id: "Combined-Shape",
    fill: "#FFFFFF"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileOn);
export default __webpack_public_path__ + "static/media/profile-on.6f0626a78714d51da4c1d62f894509a2.svg";
export { ForwardRef as ReactComponent };